//export const STAFF = 'staff';
//export const MANAGER = 'manager';
//export const COMPANY = 'company';
export const USER = 'user';
export const ADMIN = 'admin';
export const SUPERADMIN = 'superadmin';
